import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { CHAIN_NAMESPACES, getChainConfig } from '@web3auth/base';

const getDefaultExternalAdapters = async params => {
  const {
    options
  } = params;
  const {
    clientId,
    chainConfig,
    sessionTime,
    web3AuthNetwork,
    useCoreKitKey
  } = options;
  if (!Object.values(CHAIN_NAMESPACES).includes(chainConfig.chainNamespace)) throw new Error(`Invalid chainNamespace: ${chainConfig.chainNamespace}`);
  const finalChainConfig = _objectSpread(_objectSpread({}, getChainConfig(chainConfig.chainNamespace, chainConfig === null || chainConfig === void 0 ? void 0 : chainConfig.chainId)), chainConfig || {});
  const [{
    TorusWalletAdapter
  }, {
    MetamaskAdapter
  }, {
    WalletConnectV2Adapter
  }] = await Promise.all([import('@web3auth/torus-evm-adapter'), import('@web3auth/metamask-adapter'), import('@web3auth/wallet-connect-v2-adapter')]);
  const torusWalletAdapter = new TorusWalletAdapter({
    chainConfig: finalChainConfig,
    clientId,
    sessionTime,
    web3AuthNetwork,
    useCoreKitKey
  });
  const metamaskAdapter = new MetamaskAdapter({
    chainConfig: finalChainConfig,
    clientId,
    sessionTime,
    web3AuthNetwork,
    useCoreKitKey
  });
  const wcv2Adapter = new WalletConnectV2Adapter({
    chainConfig: finalChainConfig,
    clientId,
    sessionTime,
    web3AuthNetwork,
    useCoreKitKey,
    adapterSettings: {
      walletConnectInitOptions: {}
    }
  });
  return [torusWalletAdapter, metamaskAdapter, wcv2Adapter];
};

export { getDefaultExternalAdapters };
